import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AuthForm from "./AuthForm";
import Dashboard from "./Dashboard";
import ContentInput from "./ContentInput";
import IdeasList from "./IdeasList";
import SuggestionBox from "./SuggestionBox";
import ReminderInput from "./ReminderInput";
import RemindersList from "./RemindersList";
import CalendarView from "./CalendarView";
import Navbar from "./Navbar";
import Footer from "./Footer";


function App() {
  return (
    <Router>
      <div style={{ padding: "20px" }}>
        <Routes>
          <Route path="/" element={<AuthForm />} />

          {/* Protected pages with navbar */}
          <Route
            path="/dashboard"
            element={
              <>
                <Navbar />
                <Dashboard />
              </>
            }
          />
          <Route
            path="/ideas"
            element={
              <>
                <Navbar />
                <ContentInput />
                <IdeasList />
              </>
            }
          />
          <Route 
            path="/suggestions" 
            element={
              <>
                <Navbar />
                <SuggestionBox />
              </>
            } 
            />
          <Route
            path="/reminders"
            element={
              <>
                <Navbar />
                <ReminderInput />
                <RemindersList />
              </>
            }
          />
          <Route
            path="/calendar"
            element={
              <>
                <Navbar />
                <CalendarView />
              </>
            }
          />
          <Route
            path="/settings"
            element={
              <>
                <Navbar />
                <h2>Settings Page (Coming soon)</h2>
              </>
            }
          />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
